import { getCookie, setCookie } from '@helpers';
import { create } from '@terminal/utils/store/createStore';
import { setDefaultOptions } from 'date-fns';
import { ja } from 'date-fns/locale';
import { changeLanguage } from 'i18next';

const NEXT_LOCALE_COOKIE_KEY = 'NEXT_LOCALE';

export type LanguageStore = {
  languageSetting: string;
  selectLanguage: (languageSetting: string) => void;
};

const updatePackageLocale = (languageSetting: string) => {
  changeLanguage(languageSetting);
  setDefaultOptions({ locale: languageSetting === 'ja' ? ja : undefined });
};

const getLanguage = () => {
  const fromBrowser = window.navigator.language.substring(0, 2);

  const fromCookie = () => {
    const language = getCookie(NEXT_LOCALE_COOKIE_KEY);

    if (typeof language === 'string') {
      return language;
    }

    return undefined;
  };

  return fromCookie() || fromBrowser || 'en';
};

export const useLanguageStore = create<LanguageStore>(set => ({
  languageSetting: getLanguage(),
  selectLanguage: (languageSetting: string) => {
    set({ languageSetting });
    setCookie(NEXT_LOCALE_COOKIE_KEY, languageSetting, { expires: 365 });
    updatePackageLocale(languageSetting);
  },
}));
